module.exports = __webpack_public_path__ + "static/img/pic_2_4@2x.fa3ffce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/anchorOperation/shortVideo/pic_2_4@2x.png
// module id = tfkw
// module chunks = 0